import React from "react"
import { connect } from "react-redux"

import { setShowSiteCredit } from "../../state/global"

const SiteCredit = ({ showSiteCredit, mobile, dispatch }) => {
  return (
    <div id="siteCredit" className={`${showSiteCredit ? "show" : ""}`}>
      <div>
        Design:{" "}
        <a
          role="button"
          tabIndex={0}
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.alright.studio"
        >
          Alright Studio
        </a>
      </div>
      <span>•</span>
      <div>
        Development:{" "}
        <a
          role="button"
          tabIndex={0}
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.istuckerworking.com"
        >
          Tucker Schoos
        </a>
      </div>
      <span>•</span>
      <div>
        Design Support:{" "}
        <a
          role="button"
          tabIndex={0}
          target="_blank"
          rel="noopener noreferrer"
          href="https://clintsoren.com/"
        >
          Clint Soren
        </a>
      </div>
      <span>•</span>
      <div>
        Illustrations:{" "}
        <a
          role="button"
          tabIndex={0}
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.instagram.com/rhymezlikedimez/"
        >
          @rhymezlikedimez
        </a>
      </div>
      <div
        role="button"
        tabIndex={0}
        onKeyDown={() => dispatch(setShowSiteCredit(false))}
        onClick={() => dispatch(setShowSiteCredit(false))}
        className="close"
      >
        [close]
      </div>
    </div>
  )
}

export default connect(
  state => ({
    modal: state.global.modal,
    showSiteCredit: state.global.showSiteCredit,
  }),
  null
)(SiteCredit)
